import { createApp } from "vue"
import "@/assets/style/styles.css" // Add styles above App in order to make it appear before the components styles in the head sections, since these are mostly global styles
import App from "./App.vue"
import store from "./store"

createApp( App ).use( store ).mount( "#app" )